<template>

    <q-select
        class="mw-form-v2-select"
        :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense" v-model="fieldValue"
              ref="selectlo"
              use-input
              :options="options"
              emit-value
              option-value="value"
              option-label="label"
              map-options
              @filter="filterFn"
              clearable
              debounce="500"
              :label="field.layout_injected_label ? field.layout_injected_label : field.label"
              :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
    >
      <template v-slot:label>
        {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-select>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  components: {OptionalLabel},
  data() {
    return {
      value: null,
      options: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    filterFn (val, update) {
      if (val === '') {
        update(() => {
          this.options = this.optionsForSelect

          // here you have access to "ref" which
          // is the Vue reference of the QSelect
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.options = this.optionsForSelect.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
  },
  watch: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      for (const [key, value] of Object.entries(this.field.options)) {
        data.push( {
          label: value,
          value: key
        });
      }
      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {
    this.options = this.optionsForSelect
  }
}
</script>
